import Rails from "@rails/ujs"

import 'mypage/css/bootstrap.mina560.css'
import 'mypage/css/system/system.base.css'
import 'mypage/css/system/system.messages.css'
import 'mypage/css/style.css'
import 'mypage/css/j-custom.css'
import 'mypage/css/custom-styles.css'
import 'registerpage/css/form.css'
import 'registerpage/css/jzd-step-forms.css'

import 'jquery'
import 'registerpage/js/jzd-js-step-form-modal'
import 'registerpage/js/jzd-js-step-open'
import 'registerpage/js/select-birthday'
import 'registerpage/js/input-filter'
import 'registerpage/js/phonenumber-guildance'
import 'mypage/js/header'

Rails.start()

window.jQuery = $;
window.$ = $;
